import { render, staticRenderFns } from "./edit_menu.vue?vue&type=template&id=5e70df2b&scoped=true"
import script from "./edit_menu.vue?vue&type=script&lang=js"
export * from "./edit_menu.vue?vue&type=script&lang=js"
import style0 from "./edit_menu.vue?vue&type=style&index=0&id=5e70df2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e70df2b",
  null
  
)

export default component.exports